import classNames from "classnames";
import * as React from "react";

import styles from "./EmptyState.module.css";

export interface EmptyStateProps {
  title: React.ReactNode;
  /** The title's heading level, to fit the page's outline. Defaults to 2. */
  headingLevel?: 2 | 3 | 4;
  /** Buttons or links that get the list started. */
  actions?: React.ReactNode;
  className?: string;
  "data-testid"?: string;
  /** What the list is for and how to fill it. */
  children?: React.ReactNode;
}

/** A dashed card that stands in for a list with nothing in it yet. */
export function EmptyState({
  title,
  headingLevel = 2,
  actions,
  className,
  "data-testid": testId,
  children,
}: EmptyStateProps) {
  const Heading = `h${headingLevel}` as const;
  return (
    <div className={classNames(styles.empty, className)} data-testid={testId}>
      <Heading className={styles.title}>{title}</Heading>
      {children !== undefined && <div className={styles.body}>{children}</div>}
      {actions !== undefined && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
